var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 15.8333C18.3332 16.2754 18.1576 16.6993 17.845 17.0118C17.5325 17.3244 17.1085 17.5 16.6665 17.5H3.33317C2.89114 17.5 2.46722 17.3244 2.15466 17.0118C1.8421 16.6993 1.6665 16.2754 1.6665 15.8333V4.16667C1.6665 3.72464 1.8421 3.30072 2.15466 2.98816C2.46722 2.67559 2.89114 2.5 3.33317 2.5H7.49984L9.1665 5H16.6665C17.1085 5 17.5325 5.17559 17.845 5.48816C18.1576 5.80072 18.3332 6.22464 18.3332 6.66667V15.8333Z",
    stroke: "#475569",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12996_23462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 14V13.3333C9.66683 12.9797 9.52635 12.6406 9.27631 12.3905C9.02626 12.1405 8.68712 12 8.3335 12H5.66683C5.31321 12 4.97407 12.1405 4.72402 12.3905C4.47397 12.6406 4.3335 12.9797 4.3335 13.3333V14",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 10.6667C7.73622 10.6667 8.33317 10.0697 8.33317 9.33333C8.33317 8.59695 7.73622 8 6.99984 8C6.26346 8 5.6665 8.59695 5.6665 9.33333C5.6665 10.0697 6.26346 10.6667 6.99984 10.6667Z",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12996_23462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyContentIcon);
export default __webpack_public_path__ + "static/media/MyContentIcon.0c1595e38f4d186cb14ee93b5fcc40ee.svg";
export { ForwardRef as ReactComponent };